/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentNoShows from './AppointmentNoShows/index'
import BrokenBrackets from './BrokenBrackets/index'
import CancelledAppointments from './CancelledAppointments/index'
import OralHygiene from './OralHygiene/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Reporting/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<AppointmentNoShows
  viewPath={`${viewPath}/AppointmentNoShows`}
/>
<CancelledAppointments
  viewPath={`${viewPath}/CancelledAppointments`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<OralHygiene
  viewPath={`${viewPath}/OralHygiene`}
/>
<BrokenBrackets
  viewPath={`${viewPath}/BrokenBrackets`}
/>
</div>
</div>
{children}
</React.Fragment>)
}